/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface UploadAttachmentsResponse {
  attachment_ids: string[];
  presigned_urls: string[];
}
